// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3B1VG","label":"Completed_label__issZl"};